import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { AuthContextProvider, NotificationProvider } from 'src/contexts';

import AppRouter from './routes/AppRouter';
import Providers from './providers/providers';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/common/ScrollToTop';

import {
  TransactionsToastList,
} from "@multiversx/sdk-dapp/UI";

import { AuthenticatedRoutesWrapper } from '@multiversx/sdk-dapp/wrappers/AuthenticatedRoutesWrapper';
import { DappProvider } from '@multiversx/sdk-dapp/wrappers/DappProvider';
import { SignTransactionsModals } from '@multiversx/sdk-dapp/UI/SignTransactionsModals';

const domain = process.env.REACT_APP_AUTH0_DOMAIN as string;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE as string;
const MVX_ENVIRONMENT = process.env.REACT_APP_MVX_ENVIRONMENT as string;
console.log('MVX_ENVIRONMENT', MVX_ENVIRONMENT)
const mvx_protected_routes = [
  {
    path: "/mvxtest",
    title: "MVX Test",
    component: () => <div>MVX Test</div>,
    authenticatedRoute: true,
  }
];

export default function App() {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  useEffect(() => {
    const error = searchParams.get('error');

    if (error === 'access_denied') {
      navigate('/sign-up/borrower', {
        replace: true,
        state: { emailNotification: true },
      });
    }
  }, [searchParams]);

  return (
    <Providers>
      <DappProvider
          environment={MVX_ENVIRONMENT}
      >
      {/* <AuthenticatedRoutesWrapper routes={mvx_protected_routes} unlockRoute='/unlock'> */}
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        redirectUri={window.location.origin}
        audience={audience}
        onRedirectCallback={(appState?: AppState) => {
          navigate(appState?.returnTo || '/', { replace: true });
        }}
        cacheLocation="localstorage"
      >
        <AuthContextProvider>
          <NotificationProvider>
            <ToastContainer />
            <SignTransactionsModals />
            {/* <TransactionsToastList /> */}
            <AppRouter />
            {/* <ScrollToTop></ScrollToTop> */}
          </NotificationProvider>
        </AuthContextProvider>
      </Auth0Provider>
      {/* </AuthenticatedRoutesWrapper> */}
      </DappProvider>
    </Providers>
  );
}
